import { ICompany } from 'app/shared/model/company.model';
import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { IVehiclePosition } from 'app/shared/model/vehicle-position.model';

export interface IIdentificationCodeAlert {
  id?: number;
  value?: string | null;
  created?: string | null;
  truckImplement?: ITruckImplement | null;
  company?: ICompany | null;
  vehiclePosition?: IVehiclePosition | null;
}

export const defaultValue: Readonly<IIdentificationCodeAlert> = {};
